import script from "./RolFormListView.vue?vue&type=script&setup=true&lang=js"
export * from "./RolFormListView.vue?vue&type=script&setup=true&lang=js"

import "./RolFormListView.vue?vue&type=style&index=0&id=6decdafc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6decdafc"]])

export default __exports__